import { api } from "@/lib/apiClient";
import type { InquiryEmailVariant } from "@/components/bookings/InquiryEmailModal";
import type { Booking } from "@/types/camping";

export interface SendInquiryEmailInput {
  to_address?: string | null;
  subject?: string | null;
  body_text?: string | null;
  variant: InquiryEmailVariant;
}

export async function sendInquiryEmail(
  bookingId: string,
  input: SendInquiryEmailInput,
): Promise<void> {
  await api.post(`/api/v1/bookings/${bookingId}/inquiry-email/send`, {
    to_address: input.to_address?.trim() || null,
    subject: input.subject?.trim() || null,
    body_text: input.body_text?.trim() || null,
    variant: input.variant,
  });
}

export interface InquiryAmendInput {
  version: number;
  pitch_category_id?: string;
  arrival_date?: string;
  departure_date?: string;
}

export interface InquiryAmendPreview {
  changes: string[];
  arrival_date: string;
  departure_date: string;
  nights: number;
  pitch_category_id: string | null;
  pitch_category_name: string | null;
  total_amount: string;
  currency: string;
  price_pending: boolean;
}

export function previewInquiryAmendment(
  bookingId: string,
  input: InquiryAmendInput,
): Promise<InquiryAmendPreview> {
  return api.post<InquiryAmendPreview>(
    `/api/v1/bookings/${bookingId}/inquiry-amendment/preview`,
    input,
  );
}

export function amendInquiry(bookingId: string, input: InquiryAmendInput): Promise<Booking> {
  return api.post<Booking>(`/api/v1/bookings/${bookingId}/inquiry-amendment`, input);
}

export async function confirmBookingInquiry(
  bookingId: string,
  options?: { skipConfirmationEmail?: boolean },
): Promise<Booking> {
  return api.post<Booking>(`/api/v1/bookings/${bookingId}/confirm`, {
    skip_confirmation_email: Boolean(options?.skipConfirmationEmail),
  });
}

export function confirmRejectBookingInquiry(booking: Booking): boolean {
  const guest = booking.guest_name?.trim();
  const who = guest ? ` für ${guest}` : "";
  return window.confirm(
    `Anfrage ${booking.booking_number}${who} ablehnen?\n\nDie Buchung wird als „Abgelehnt“ geführt.`,
  );
}

export async function rejectBookingInquiry(booking: Booking): Promise<Booking> {
  const version = booking.version ?? 1;
  return api.patch<Booking>(`/api/v1/bookings/${booking.id}`, {
    version,
    status: "rejected",
  });
}
